import React, { useState } from 'react';
import CityAutocomplete from '../../CityAutocomplete/CityAutocomplete';
import LocationSearch from '../../LocationSearch/LocationSearch';

const LocationStep = ({ formData, onNext, onBack }) => {
  const [localData, setLocalData] = useState({
    city: formData.city || '',
    homeLocation: formData.homeLocation || { city: '', country: '', formatted: '' },
  });
  const [errors, setErrors] = useState({});

  const handleCityChange = (e) => {
    const value = e.target ? e.target.value : e;
    setLocalData((prev) => ({ ...prev, city: value }));

    if (errors.city) {
      setErrors((prev) => ({ ...prev, city: '' }));
    }
  };

  const handleHomeLocationChange = (location) => {
    setLocalData((prev) => ({ ...prev, homeLocation: location }));

    if (errors.homeLocation) {
      setErrors((prev) => ({ ...prev, homeLocation: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!localData.city.trim()) {
      newErrors.city = 'Please select where you dance now';
    }

    if (!localData.homeLocation.formatted) {
      newErrors.homeLocation = 'Please select where you are from';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      onNext(localData);
    }
  };

  return (
    <div className="wizard-step">
      <h2 className="step-title">Your Location</h2>
      <p className="step-subtitle">Let us know where you dance and where you're from</p>

      <form onSubmit={handleSubmit}>
        {/* City - Where you dance now */}
        <div className="wizard-field">
          <CityAutocomplete
            value={localData.city}
            onChange={handleCityChange}
            label="Where do you dance now?"
            placeholder="Search for a city..."
            required
            error={errors.city}
          />
          <p className="field-hint">
            <i className="bi bi-info-circle"></i>
            This helps us show you local events
          </p>
        </div>

        {/* Home Location - Where are you from */}
        <div className="wizard-field">
          <LocationSearch
            value={localData.homeLocation}
            onChange={handleHomeLocationChange}
            label="Where are you from?"
            placeholder="Search for a city or country..."
            required
            error={errors.homeLocation}
          />
        </div>

        {/* Navigation */}
        <div className="wizard-navigation">
          <button type="button" className="wizard-btn wizard-btn-back" onClick={onBack}>
            <i className="bi bi-arrow-left"></i>
            Back
          </button>
          <button type="submit" className="wizard-btn wizard-btn-next">
            Next
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>
      </form>
    </div>
  );
};

export default LocationStep;
